const trackingEventNames = {
  AccessData: {
    student: {
      openModalEditPassword: 'access_data:open_modal_edit_password:edit_password_link:click',
      responsePasssword: 'access_data:response_password:click',
      savePasssword: 'access_data:save_password:save_password_button:click',
    },
  },
}

export { trackingEventNames }
